<template>
  <div class="login-wrapper">
      <Register/>
  </div>
</template>

<script>
import Register from "../../components/user/Register"
export default {
    components:{
        Register
    },
    created(){

    },
    methods:{

    }
}
</script>

<style scoped>
.login-wrapper{
    max-width: 500px;
    margin: 50px auto;
    background: #ffffff99;
    padding: 20px;
    /* box-shadow: #b48ef1 0 0 10px 3px; */
}

</style>